import { StoreResult } from '@/store/CertificateStore';
import { AbstractSignatureStrategy } from './AbstractSignatureStrategy';
import Dictionary from '@/types/Dictionary';
import { router } from '@/App.vue';
import { Resource, SMACertificate } from '@/types/Administration/SMA/SMACertificate';

export class SessionLessSignature extends AbstractSignatureStrategy {

    /**
     * Demande de validation par mot de passe
     */
    public readonly requiresPasswordValidation = false;

    /**
     * Récupération du mandat format base
     * @param parameters 
     */
    public override async execute({ item: certificate, resource: resources }: { item: SMACertificate; resource: Resource[] }): Promise<StoreResult<Blob>> {
        const tokenFromUrl = router.currentRoute.params.token;
        let response: any = null;
        
        console.debug("Token extrait de l'URL :", tokenFromUrl);

        const requestParameters = {
            token: tokenFromUrl
        };
        try {
            response = await this.store.dispatch("CertificateStore/DownloadByToken", requestParameters);
            console.debug("Downloaded data success", response);
            return response;
        } catch (error) {
            console.error("Erreur lors du téléchargement", response);
            return response;
        }
    }

    /**
     * Submit de la signature client
     * @param parameters 
     */
    public override async validation(parameters: Dictionary<any>): Promise<StoreResult<Blob>> {
        const tokenFromUrl = router.currentRoute.params.token;

        console.debug("clientValidation :", parameters);

        return await this.store.dispatch("CertificateStore/ClientValidationSessionLess", { 
            Token: tokenFromUrl,
            Base64File: parameters.Base64File,
        });
    }
}